/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Clip': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M22 26V4.526C22 3.131 20.854 2 19.44 2H8.56C7.146 2 6 3.131 6 4.526V26l8-7.791L22 26z"/><path pid="1" d="M22 26V4.526C22 3.131 20.854 2 19.44 2H8.56C7.146 2 6 3.131 6 4.526V26l8-7.791L22 26z" _stroke="#2D75F5"/></g>'
  }
})
